var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerChartsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89014 8.28009L8.89014 89.3101C8.89014 92.5023 11.4779 95.0901 14.6701 95.0901L133.94 95.0901C137.132 95.0901 139.72 92.5023 139.72 89.3101V8.28009C139.72 5.08788 137.132 2.50009 133.94 2.50009L14.6701 2.50009C11.4779 2.50009 8.89014 5.08788 8.89014 8.28009Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.41 134C147.41 141.46 144.79 147.51 138.29 147.51C131.79 147.51 129.17 141.46 129.17 134C129.17 126.54 130.51 120.5 138.29 120.5C146.07 120.5 147.41 126.54 147.41 134Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0601 23.6799C46.3252 23.6799 41.6967 25.084 37.7598 27.7145C33.8229 30.3451 30.7544 34.084 28.9425 38.4585C27.1305 42.833 26.6564 47.6465 27.5801 52.2904C28.5039 56.9343 30.7839 61.2 34.132 64.5481C37.4801 67.8961 41.7458 70.1762 46.3897 71.0999C51.0336 72.0237 55.8471 71.5496 60.2216 69.7376C64.596 67.9256 68.335 64.8572 70.9655 60.9203C73.5961 56.9834 75.0001 52.3548 75.0001 47.6199C75.0001 41.2706 72.4779 35.1814 67.9883 30.6918C63.4986 26.2022 57.4094 23.6799 51.0601 23.6799ZM51.0601 61.6799C48.2717 61.6819 45.5454 60.8565 43.2263 59.3081C40.9073 57.7597 39.0998 55.5581 38.0327 52.9819C36.9656 50.4057 36.6869 47.5709 37.2319 44.8362C37.7768 42.1015 39.121 39.59 41.0941 37.6197C43.0672 35.6494 45.5806 34.3088 48.3161 33.7677C51.0515 33.2267 53.886 33.5094 56.4606 34.5801C59.0353 35.6509 61.2344 37.4615 62.7794 39.7827C64.3245 42.104 65.1461 44.8315 65.1401 47.6199C65.1401 49.4689 64.7759 51.2999 64.0684 53.0081C63.3608 54.7164 62.3236 56.2685 61.0162 57.576C59.7087 58.8834 58.1566 59.9206 56.4483 60.6282C54.74 61.3357 52.9091 61.6999 51.0601 61.6999V61.6799Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 22.6299H99.4102V53.6299H107.74V22.6299Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8199 93.48V98.9C86.9899 107.9 96.4499 111.19 96.4499 111.19H52.1699C52.1699 111.19 61.9999 107.77 63.9199 98.38V94.55",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9399 84.02V9.54004H132.68",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.68 9.54004V84.02H15.9399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9399 138.11L23.9999 118.84H108.54L117.6 138.11",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.69 123.87H27.56L20.98 138.11",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5901 123.87L27.3901 136.07",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6302 123.87L34.7402 130.63",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6803 128.9H25.5503",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6202 133.94H22.9102",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6802 95.0901C97.0002 106.29 104.36 110.17 113.48 109.2C120.41 108.46 122.67 103.74 121.05 101.87C117.3 97.5401 111.75 109.16 119.34 114.87C125.34 119.51 135.57 110.72 137.75 121.56V130.64",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.13 131.17H149.11",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 64.25H122.97",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3403 69.28H112.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0599 22.1101V47.6201L42.1499 71.1401",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2603 41.4099L51.5003 48.0599",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.73 23.8899L51.06 48.0599",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6602 54.36V34.97H93.9902V54.36",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 54.3601V45.3501H121.49V54.3601",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerChartsGrey);
export default __webpack_public_path__ + "static/media/computer_charts_grey.48e8528efdc767dbff4ce08c136bccad.svg";
export { ForwardRef as ReactComponent };